<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-toolbar rounded>
          <h1>Noticias</h1>

          <v-spacer></v-spacer>
          <v-btn
            color="#0361B2"
            dark
            @click="AutenticarUsuario()"
            v-if="local_storage"
            class="mx-1"
          >
            iniciar sesión con One Drive
          </v-btn>
          <v-btn color="primary" @click="nuevaNoticia()" v-if="!local_storage">
            Nuevo
          </v-btn>
          <v-tooltip bottom v-if="!local_storage">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                @click="listarNoticias()"                
              >
                <v-icon>fas fa-redo-alt</v-icon>
              </v-btn>
            </template>
            <span>Recargar Noticias</span>
          </v-tooltip>
        </v-toolbar>
      </v-col>

      <v-col cols="4" v-for="(item, i) in items" :key="i">
        <v-card>
          <v-card-title class="white pa-0">
            <v-img :src="item.imagen" width="300" height="200" contain></v-img>
          </v-card-title>
          <v-card-title>{{ item.titulo }}</v-card-title>
          <v-card-subtitle>{{ formatoFecha(item.fecha_hora) }}</v-card-subtitle>
          <v-card-text class="text--primary">
            {{ item.descripcion }}
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="editarNoticias(item)">
              Editar
            </v-btn>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <a
                  :href="item.url"
                  v-if="item.url"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon> fas fa-share-square </v-icon>
                </a>
              </template>
              <span>{{ item.url }}</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog_nuevo" width="500">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-file-input
            v-model="imagen"
            label="Imagen"
            outlined
            dense
            hide-details
          ></v-file-input>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="titulo"
                label="TITULO"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="descripcion"
                label="DESCRIPCION"
                outlined
                dense
                hide-details
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="url"
                label="URL"
                hint="https://www.google.com"
                persistent-hint
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="crearNoticias()"
            v-if="flag_new_edit == 1"
            :loading="loading_btn"
            >Publicar</v-btn
          >
          <v-btn
            color="primary"
            @click="actualizarNoticia()"
            v-if="flag_new_edit == 2"
            :loading="loading_btn"
            >Actualizar</v-btn
          >
          <v-btn
            color="red"
            dark
            @click="eliminarNoticia()"
            v-if="flag_new_edit == 2"
            >Eliminar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialog()">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import PictureInput from "vue-picture-input";
import one_drive_api from "../../view/OneDriveApi";

export default {
  data: () => ({
    dialog_nuevo: false,
    items: [],
    id_noticias: 0,
    titulo: "",
    fecha_hora: "",
    descripcion: "",
    url: "",
    flag_new_edit: 1,
    id_imagen: "",
    imagen: [],
    credenciales: [],
    edit_img: false,
    loading_btn: false,
    local_storage: true,
  }),
  components: {
    PictureInput,
  },
  created() {
    this.listarNoticias();
    this.tiene_cred_one_drive();
  },
  methods: {
    listarNoticias() {
      this.items = [];
      axios.get("api/Noticias/Listar").then((response) => {
        //console.log(response.data);
        response.data.forEach(async (element) => {
          var result = await this.verImagen(element.id_noticias);
          //console.log(result);

          this.items.push({
            id_noticias: element.id_noticias,
            titulo: element.titulo,
            descripcion: element.descripcion,
            url: element.url,
            id_imagen: (result.id = "" ? "" : result.id),
            imagen: (result.webUrl = "" ? "" : result.webUrl),
            fecha_hora: element.fecha_hora,
          });
        });
      });
    },
    nuevaNoticia() {
      this.flag_new_edit = 1;
      this.edit_img = true;
      this.dialog_nuevo = true;
    },
    crearNoticias() {
      var date = new Date();
      this.fecha_hora =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes();

      axios
        .post("api/Noticias/Crear", {
          titulo: this.titulo,
          fecha_hora: this.fecha_hora,
          descripcion: this.descripcion,
          url: this.url,
        })
        .then((response) => {
          this.loading_btn = true;
          if (this.imagen.length == 0) {
            this.cerrarDialog();
            this.listarNoticias();
            this.loading_btn = false;
            return;
          }
          this.crearSesionCarga(response.data);
        })
        .catch(() => {
          this.loading_btn = false;
        });
    },
    actualizarNoticia() {
      axios
        .put("api/Noticias/Actualizar", {
          id_noticias: this.id_noticias,
          titulo: this.titulo,
          fecha_hora: this.fecha_hora,
          descripcion: this.descripcion,
          url: this.url,
        })
        .then((response) => {
          this.loading_btn = true;

          if (this.imagen.length == 0) {
            this.cerrarDialog();
            this.listarNoticias();
            this.loading_btn = false;
            return;
          }
          this.crearSesionCarga(response.data);
        })
        .catch(() => {
          this.loading_btn = false;
        });
    },
    eliminarNoticia() {
      axios.delete("api/Noticias/Eliminar/" + this.id_noticias).then(() => {
        this.cerrarDialog();
        this.listarNoticias();
      });
    },
    editarNoticias(item) {
      //console.log(item);
      this.id_noticias = item.id_noticias;
      this.titulo = item.titulo;
      this.fecha_hora = item.fecha_hora;
      this.descripcion = item.descripcion;
      this.url = item.url;

      if (item.imagen) {
        this.id_imagen = item.id_imagen;
      }

      this.flag_new_edit = 2;
      this.dialog_nuevo = true;
    },
    cerrarDialog() {
      this.dialog_nuevo = false;
      this.limpiar();
    },
    limpiar() {
      this.titulo = "";
      this.fecha_hora = "";
      this.descripcion = "";
      this.url = "";
      this.imagen = [];
    },
    formatoFecha(fecha) {
      return moment(fecha).format("DD-MM-YYYY HH:MM");
    },
    //ONE DRIVE
    async tiene_cred_one_drive() {
      const inter = setInterval(async () => {
        var credenciales_drive = await one_drive_api.listarCredencialesOneDrive(
          this.$store.state.usuario.idUsuario
        );
        if (credenciales_drive.length > 0) {
          localStorage.setItem("credentials", "si");
          this.flag_credenciales();
          clearInterval(inter);
        }
      }, 1000);
    },
    flag_credenciales() {
      if (localStorage.getItem("credentials")) {
        this.local_storage = false;
      } else {
        this.local_storage = true;
      }
    },
    async crearSesionCarga(id_noticia) {
      var credenciales_drive = await one_drive_api.listarCredencialesOneDrive(
        this.$store.state.usuario.idUsuario
      );
      var refresh_token = this.desencriptarDato(
        this.getLlave("refresh_token", credenciales_drive).valor
      );
      var result = await axios.post("api/Usuarios/ObtenerNuevoToken", {
        redirect_uri: "http://localhost:8080/authGoogleDrive",
        refresh_token: refresh_token,
      });

      let header = {
        Authorization: "Bearer " + result.data.access_token,
        "Content-Type": "application/json",
      };
      let configuracion = { headers: header };

      await axios
        .post(
          "https://graph.microsoft.com/v1.0/me/drive/root:/INTRANET/NOTICIAS" +
            "/" +
            id_noticia +
            "/" +
            this.imagen.name +
            ":/createUploadSession",
          {},
          configuracion
        )
        .then((response) => {
          this.crearArchivo(response.data.uploadUrl, this.imagen);
        });
    },
    crearArchivo(uploadUrl, archivo) {
      let me = this;
      const async = require("async");

      if (this.id_imagen) {
        this.eliminarImagen();
      }

      async.eachSeries(this.getSizes(archivo), function (st, callback) {
        setTimeout(async function () {
          let header = {
            "Content-Length": st.clen,
            "Content-Range": st.cr,
          };
          let configuracion = { headers: header };
          await axios.put(uploadUrl, archivo, configuracion);

          me.cerrarDialog();
          me.listarNoticias();
          me.loading_btn = false;

          callback();
        }, st.stime);
      });
    },
    async verImagen(id_noticias) {
      var credenciales_drive = await one_drive_api.listarCredencialesOneDrive(
        this.$store.state.usuario.idUsuario
      );
      var refresh_token = this.desencriptarDato(
        this.getLlave("refresh_token", credenciales_drive).valor
      );
      var response = await axios.post("api/Usuarios/ObtenerNuevoToken", {
        redirect_uri: "http://localhost:8080/authGoogleDrive",
        refresh_token: refresh_token,
      });

      let header = {
        Authorization: "Bearer " + response.data.access_token,
        "Content-Type": "application/json",
      };
      let configuracion = { headers: header };

      var result = await axios
        .get(
          "https://graph.microsoft.com/v1.0/me/drive/root:/" +
            "INTRANET/NOTICIAS/" +
            id_noticias +
            ":/children",
          configuracion
        )
        .catch((error) => {
          return error.response;
        });

      if (result.status == 404) {
        return "";
      }

      return result.data.value[0];
    },
    async eliminarImagen() {
      var credenciales_drive = await one_drive_api.listarCredencialesOneDrive(
        this.$store.state.usuario.idUsuario
      );
      var refresh_token = this.desencriptarDato(
        this.getLlave("refresh_token", credenciales_drive).valor
      );
      var result = await axios.post("api/Usuarios/ObtenerNuevoToken", {
        redirect_uri: "http://localhost:8080/authGoogleDrive",
        refresh_token: refresh_token,
      });

      let header = {
        Authorization: "Bearer " + result.data.access_token,
        "Content-Type": "application/json",
      };
      let configuracion = { headers: header };

      var result_delete = await axios.delete(
        "https://graph.microsoft.com/v1.0/me/drive/items/" + this.id_imagen,
        configuracion
      );
      console.log(result_delete);
      return;
    },
    async obtenerNuevasCredenciales() {
      var result = await axios.post("api/OneDrives/GetOtherAccessToken", {
        refresh_token: this.credenciales[0].refresh_token,
        redirect_uri: process.env.VUE_APP_REDIRECT_URI,
      });
      await this.actualizarCredenciales(result.data);
    },
    async actualizarCredenciales(creds) {
      await axios
        .put("api/OneDrives/Actualizar", {
          id_one_drive: this.credenciales[0].id_one_drive,
          id_usuario: this.credenciales[0].id_usuario,
          access_token: creds.access_token,
          refresh_token: creds.refresh_token,
          expire_in: new Date().getTime() + 1 * 60 * 60 * 1000,
        })
        .then(async () => {
          console.log("credenciales creadas");
          await this.tiene_cred_one_drive();
        });
    },
    getSizes(file) {
      var allsize = file.size;
      var sep = allsize < 60 * 1024 * 1024 ? allsize : 60 * 1024 * 1024 - 1;
      var ar = [];
      for (var i = 0; i < allsize; i += sep) {
        var bstart = i;
        var bend = i + sep - 1 < allsize ? i + sep - 1 : allsize - 1;
        var cr = "bytes " + bstart + "-" + bend + "/" + allsize;
        var clen = bend != allsize - 1 ? sep : allsize - i;
        var stime = allsize < 60 * 1024 * 1024 ? 5000 : 10000;
        ar.push({
          bstart: bstart,
          bend: bend,
          cr: cr,
          clen: clen,
          stime: stime,
        });
      }
      return ar;
    },
    AutenticarUsuario() {
      one_drive_api.AuthUsuario();
    },
    getLlave(clave, credenciales = []) {
      for (var i = 0; i < credenciales.length; i++) {
        if (credenciales[i]["clave"] == clave) {
          return credenciales[i];
        }
      }
    },
    desencriptarDato(data) {
      var CryptoJS = require("crypto-js");
      var bytes = CryptoJS.AES.decrypt(data, "R3gi0n@l_2@22");
      return bytes.toString(CryptoJS.enc.Utf8);
    },
  },
};
</script>